module.exports = __webpack_public_path__ + "img/feedback-given.51b60370.svg";